import "./PasswordForm.scss";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input } from "@mui/base/Input";
import { useAppDispatch } from "store";
import CustomButton from "components/Button/Button";
import { PASSWORD_REGEXP } from "constants/validation";
import { setupPassword, resendOTP } from "store/reducers/setupPassword";
import { useState } from "react";

const validationSchema = () => {
  return Yup.object().shape({
    password: Yup.string()
      .matches(PASSWORD_REGEXP, "Password does not meet requirements")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), undefined], "Passwords must match")
      .required("Confirm password is required"),
    verificationCode: Yup.string().required("Verification code is required"),
  });
};
const PasswordForm = () => {
  const [isResendCode, setIsResendCode] = useState(false);
  const dispatch = useAppDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get("userId") || "";
  const code = urlParams.get("code") || "";

  const resendCode = async (values: any) => {
    setIsResendCode(false);
    const response = await dispatch(resendOTP({ userId: userId }));
    if (
      resendOTP.rejected.match(response) ||
      resendOTP.fulfilled.match(response)
    ) {
      setIsResendCode(true);
    }
  };

  return (
    <div className="password-form-container">
      <div className="setting-title">Set your password</div>
      <Formik
        initialValues={{
          password: "",
          confirmPassword: "",
          verificationCode: code,
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setErrors, resetForm }) => {
          const response = await dispatch(
            setupPassword({
              userId: userId,
              newPassword: values.confirmPassword,
              otpCode: values.verificationCode,
            })
          );
          if (setupPassword.rejected.match(response)) {
            if (response.payload?.find((error) => error.field == "otpCode")) {
              setErrors({
                verificationCode: "Oops! Code expired.",
              });
              setIsResendCode(true);
            }
          }
          if (!Array.isArray(response.payload) && response.payload?.isSet) {
            resetForm();
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isValid,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => {
          return (
            <Form className="signin-form">
              <Input
                name="password"
                type="text"
                placeholder="Password"
                value={values.password}
                id="password"
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("password", e.target.value.trim());
                }}
                className={
                  touched.password && errors.password ? "error-field" : ""
                }
              />
              <ErrorMessage
                name={"password"}
                render={(msg) => <div className="error-message">{msg}</div>}
              />
              <div className="password-requirements">
                <div>Your password should contain:</div>
                <ul>
                  <li>At least 8 or more characters.</li>
                  <li>At least one capital letter (A-Z).</li>
                  <li>At least one lower case letter (a-z).</li>
                  <li>At least one number (0-9).</li>
                </ul>
              </div>
              <Input
                name="confirmPassword"
                type="text"
                placeholder="Confirm password"
                id="confirmPassword"
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("confirmPassword", e.target.value.trim());
                }}
                className={
                  touched.confirmPassword && errors.confirmPassword
                    ? "error-field"
                    : ""
                }
              />
              <ErrorMessage
                name={"confirmPassword"}
                render={(msg) => <div className="error-message">{msg}</div>}
              />
              <Input
                name="verificationCode"
                type="text"
                value={values.verificationCode}
                placeholder="Verification code"
                id="verificationCode"
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("verificationCode", e.target.value.trim());
                }}
                className={
                  touched.verificationCode && errors.verificationCode
                    ? "error-field"
                    : ""
                }
              />
              <div className="verification-code-container">
                <ErrorMessage
                  name={"verificationCode"}
                  render={(msg) => <div className="error-message">{msg}</div>}
                />
                {isResendCode && (
                  <div
                    className="resend-code"
                    onClick={() => {
                      resendCode({ userId: userId });
                    }}
                  >
                    Resend Code
                  </div>
                )}
              </div>

              <CustomButton
                type="submit"
                btnName="Save"
                className="blue-btn"
                disabled={!isValid}
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};
export default PasswordForm;
